import { conditionConstants, eventOperators } from "./condition.constants"


export const optionQuestionDictionary = (operator) => {
    switch (operator) {
        case conditionConstants.operators.EQUAL:
            return 'IsEqualToOption'
        case conditionConstants.operators.NOT_EQUAL:
            return 'IsNotEqualToOption'
        case conditionConstants.operators.ANY:
            return "AnyOptionIsSelected"
        case conditionConstants.operators.LESS_THAN:
            return "NoOptionsIsSelected"
     
            break;
    }
}

export const fieldDictionary = (operator) => {
    switch (operator) {
        case conditionConstants.operators.EQUAL:
            return 'IsEqual'
        case conditionConstants.operators.NOT_EQUAL:
            return 'IsNotEqual'
        case conditionConstants.operators.GREATER_THAN:
            return "TextLengthIsGreaterThan"
        case conditionConstants.operators.LESS_THAN:
            return "TextLengthIsLessThan"
        case conditionConstants.operators.LESS_THAN_OR_EQUAL_TO:
            return "TextLengthIsLessThanOrEqualTo"
        case conditionConstants.operators.GREATER_THAN_OR_EQUAL_TO:
            return "TextLengthIsGreaterThanOrEqualTo"
        case conditionConstants.operators.LIKE:
            return "TextIncludes"
        default:
            break;
    }
}

export const eventDictionary = (operator) => {
    switch (operator) {
        case "EQUAL":
            return 'IsChecked'
            break;
        case "NOT_EQUAL":
            return 'IsNotChecked'
        default:
            break;
    }
}

